import { render, staticRenderFns } from "./IconAiButton.vue?vue&type=template&id=d75c4ae2"
import script from "./IconAiButton.vue?vue&type=script&lang=js"
export * from "./IconAiButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports